import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { AuthProvider } from './lib/auth';
import { bouncePagesDevUrl } from './lib/publicOrigin';
import { registerServiceWorker } from './lib/registerServiceWorker';
import './styles.css';

const bounced = bouncePagesDevUrl(window.location);
if (bounced) {
  window.location.replace(bounced);
} else {
  const container = document.getElementById('root');
  if (!container) throw new Error('Missing #root element');

  createRoot(container).render(
    <StrictMode>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </StrictMode>,
  );

  registerServiceWorker();
}
